<template>
  <sub-section
    title="Your savings/investment pots"
    helpTitle="Savings/investment pots"
    :helpText="HelpText.savingsPots()"
  >
    <div v-for="saving in getSavings" v-bind:key="saving.id" class="row mb-2">
      <div class="col-9 d-flex align-items-center">
        {{ saving.description }}
      </div>
      <div class="col-3">
        <three-dot-menu
          :id="saving.id"
          :permissions="getPermissionSet()"
          :aria-purpose="saving.name"
          @editClicked="onEdit"
          @deleteClicked="onDelete"
        />
      </div>
    </div>

    <div v-show="!hasSavings">
        <empty-asset name="savings" />
    </div>

    <div class="row mt-4">
      <add-asset
        name="savings"
        longName="another saving"
        @addClicked="onAdd()"
        ref="addAssetComponent" 
      />
    </div>
  </sub-section>

  <modal :title="modalTitle" ref="assetModal" idKey="saving" close-button-aria-label="Close savings popup editor" :returnFocusTo="addAssetButton">
    <savings-editor ref="assetEditor" @edit-finished="onEditFinished" />
  </modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import ObjectBuilder from "@/guiide/ts/objectBuilder";
import Modal from "@/guiide/components/common/Modal.vue";
import SavingsEditor from "@/guiide/components/assets/SavingsEditor.vue";
import { Saving } from "@/guiide/ts/saving";
import Constants from "@/guiide/ts/constants";
import SubSection from "@/guiide/components/common/SubSection.vue";
import AddAsset from "@/guiide/components/assets/AddAsset.vue";
import EmptyAsset from "@/guiide/components/assets/EmptyAsset.vue";
import ThreeDotMenu from "@/guiide/components/common/ThreeDotMenu.vue";
import HelpText from "@/guiide/ts/helpText";
import { app } from "@/guiide/ts/app";
import PermissionSet from "@/guiide/ts/permissionSet";

export default defineComponent({
  name: "SavingsViewer",
  components: {
    Modal,
    SavingsEditor,
    SubSection,
    AddAsset,
    EmptyAsset,
    ThreeDotMenu
  },
  setup() {
    const assetModal = ref(null);
    const assetEditor = ref(null);

    return {
      assetModal,
      assetEditor,
      HelpText
    };
  },
  data() {
    return {
      modalTitle: "Edit savings",
      addAssetButton: ref<HTMLElement>(null)
    };
  },
  methods: {
    getPermissionSet() {
      return new PermissionSet(false, true, true);
    },
    onEditFinished() {
      this.assetModal.closeModal();
    },
    onAdd() {
      this.modalTitle = "Add savings";
      const saving = ObjectBuilder.createSaving(
        Constants.NewId,
        "",
        0,
        false,
        0,
        false
      );
      this.assetEditor.setValues(saving);

      const addAssetComponent = this.$refs.addAssetComponent as any;
      this.addAssetButton = addAssetComponent.getAddButton();

      this.assetModal.showModal();
    },
    onEdit(id: number) {
      this.modalTitle = "Edit savings";
      const saving = this.getSavings.filter(p => p.id == id)[0];
      this.assetEditor.setValues(saving);
      this.assetModal.showModal();
    },
    async onDelete(id: number) {
      await app.deleteOtherSavings(id);
    }
  },
  computed: {
    getSavings(): Array<Saving> {
      return this.$store.state.retiree?.savingsPots.pots ?? new Array<Saving>();
    },
    hasSavings(): boolean {
      return this.getSavings.length > 0;
    }
  }
});
</script>
